import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {
    httpGetMedicalReportByProjectKeyName,
    HttpGetMedicalReportByProjectKeyNameTypeOptions
} from '../http/medicalReports.http'
import {QUERY_KEYS} from '@/queryClient'
import {MedicalReportSmall} from '../types'

export const useGetMedicalReportByProjectKeyName = ({
    params,
    options
}: {
    params: HttpGetMedicalReportByProjectKeyNameTypeOptions['params']
    options?: Omit<UseQueryOptions<MedicalReportSmall>, 'queryKey' | 'queryFn'>
}) => {
    return useQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORTS, params],
        queryFn: () => httpGetMedicalReportByProjectKeyName({params}),
        ...options
    })
}
